export const LOGIN_DATA = "LOGIN_DATA";
export const LOGIN_ERROR_DATA = "LOGIN_ERROR_DATA";
export const LOGIN_HIDE_ERROR_DATA = "LOGIN_HIDE_ERROR_DATA";
export const LOGIN_START_LOADER = "LOGIN_START_LOADER";
export const LOGIN_STOP_LOADER = "LOGIN_STOP_LOADER";
